import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightDuoLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.46967 7.46967C6.76256 7.17678 7.23744 7.17678 7.53033 7.46967L11.5303 11.4697C11.8232 11.7626 11.8232 12.2374 11.5303 12.5303L7.53033 16.5303C7.23744 16.8232 6.76256 16.8232 6.46967 16.5303C6.17678 16.2374 6.17678 15.7626 6.46967 15.4697L9.93934 12L6.46967 8.53033C6.17678 8.23744 6.17678 7.76256 6.46967 7.46967ZM12.4697 7.46967C12.7626 7.17678 13.2374 7.17678 13.5303 7.46967L17.5303 11.4697C17.8232 11.7626 17.8232 12.2374 17.5303 12.5303L13.5303 16.5303C13.2374 16.8232 12.7626 16.8232 12.4697 16.5303C12.1768 16.2374 12.1768 15.7626 12.4697 15.4697L15.9393 12L12.4697 8.53033C12.1768 8.23744 12.1768 7.76256 12.4697 7.46967Z",
		fill: "currentColor"
	})
});
export default SvgChevronRightDuoLine;
